<div class="ms" [class.ms--drawer]="variant() === 'drawer'" [class.ms--panel]="variant() === 'panel'">

  <!-- Member savings: sage "reward" banner -->
  @if (savings() > 0) {
  <div class="ms-saved animated fadeIn">
    <span class="material-symbols-outlined ms-saved__icon">savings</span>
    <span class="ms-saved__text">
      You're saving <strong>{{ savings() | currency }}</strong> as a {{ membershipName() || 'VIP' }} member
    </span>
    @if (showBreakdown()) {
    <span class="material-symbols-outlined ms-saved__info" [ngbTooltip]="breakdownTip">info</span>
    <ng-template #breakdownTip>
      Includes
      @if (showPricingSaving()) {
      {{ breakdown()?.productPricing | currency }} in member pricing
      }
      @if (showPricingSaving() && showDeliverySaving()) {
      and
      }
      @if (showDeliverySaving()) {
      {{ breakdown()?.delivery | currency }} in delivery savings
      }
    </ng-template>
    }
  </div>
  }

  <!-- Upgrade prompt: unified copy; member = inline card, non-member = block card (full-width CTA) -->
  @if (upgrade(); as u) {
  <div class="ms-upgrade animated fadeIn" [class.ms-upgrade--block]="!isMember()">
    <span class="material-symbols-outlined ms-upgrade__icon">workspace_premium</span>
    <div class="ms-upgrade__body">
      <p class="ms-upgrade__text">
        Upgrade to {{ u.membership.name }} and save an extra
        <strong>{{ u.potentialSavingsOnOrder | currency }}</strong> on this order
      </p>
      <button type="button" class="btn btn-secondary btn-sm ms-upgrade__btn" (click)="upgradeClick.emit()">
        Upgrade
      </button>
    </div>
  </div>
  }

</div>
